import type { HomeActivityEntityType, SearchResultItem } from './api';

type SearchActivityTarget = {
  entityType: HomeActivityEntityType;
  id: string;
};

const searchableActivityTypes = new Set<HomeActivityEntityType>([
  'PLAN',
  'COMPLETION_REPORT',
  'POST_MORTEM',
  'CO_ACTION',
  'CODE_REVIEW',
  'DOCUMENT',
  'CONVENTION',
  'SKILL',
]);

export const resolveSearchActivityTarget = (item: SearchResultItem): SearchActivityTarget | null => {
  if (item.entityType === 'COMMENT') {
    // Prefer the parent entity type the API attached to the row. Fall back to PLAN for
    // older API responses where Comment always pointed at a Plan; return null if the
    // parent type is something the activity panel cannot render so the caller can use
    // the /plans/detail route as a last resort.
    const parentType = item.targetEntityType ?? 'PLAN';
    if (!searchableActivityTypes.has(parentType as HomeActivityEntityType)) {
      return null;
    }
    return {
      entityType: parentType as HomeActivityEntityType,
      id: item.targetId ?? item.id,
    };
  }

  if (searchableActivityTypes.has(item.entityType as HomeActivityEntityType)) {
    return {
      entityType: item.entityType as HomeActivityEntityType,
      id: item.id,
    };
  }

  return null;
};
